module.exports = __webpack_public_path__ + "static/media/nv-tiramisu.840738dd.jpg";